import React from 'react';
import { Grid, useTheme } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { useCustomTranslation } from '../../../translation/customTranslation';

interface RedFlagProps {
  flagKey: string;
}

export function RedFlagItem({ flagKey }: RedFlagProps) {
  const { t } = useCustomTranslation();
  const theme = useTheme();

  return (
    <Grid item display="flex" alignItems="center" columnGap={1} xs={12}>
      <CancelOutlinedIcon
        sx={{ fill: theme.palette.error.main, fontSize: '16px' }}
      />
      {t(flagKey)}
    </Grid>
  );
}
